import { Identifier } from 'react-admin'

import { postRequest } from './common'

const baseUrl = '/api/v1/console/invoices'

export function cancelInvoice(id: string) {
  let url = `${baseUrl}/${id}/cancel/`
  return postRequest(url)
}

export function sendEdiInvoice(id: Identifier, job_id: string) {
  let url = `${baseUrl}/${id}/send-edi-invoice/`
  return postRequest(url, { job_id })
}

export function updateInvoiceParsingStatus(id: Identifier, ar_parsing_status: string) {
  let url = `${baseUrl}/${id}/update-invoice-parsing-status/`
  return postRequest(url, { ar_parsing_status })
}
